// extracted by mini-css-extract-plugin
module.exports = {"pixPage":"TablePixPage_pixPage__ALFeX","container":"TablePixPage_container__2YePZ","closeButton":"TablePixPage_closeButton__2MjTI"};